import fi from '../../translations/fi.json';
import en from '../../translations/en.json';

export const defaultLocale = 'fi';

export const languages = {
  fi,
  en,
};
